import { Avatar } from './Avatar'
import { useT } from '../lib/i18n'

export interface ConsentValue {
  ai: boolean
  microphone: boolean
  camera: boolean
}

/**
 * FR "Datenschutz und Compliance": vor der ersten Nachricht und vor jedem
 * Mikrofon- oder Kamerazugriff. Sagt klar, dass hier eine KI spricht (EU AI
 * Act, Transparenzpflicht) und was mit den Daten passiert.
 *
 * Ein Satz, ein Knopf. Die drei Häkchen davor hielten jeden Besucher auf, und
 * sie entschieden nichts: Mikrofon und Kamera fragt das Gerät ohnehin erst,
 * wenn man sie zum ersten Mal nutzt — diese Nachfrage des Browsers ist die
 * eigentliche Freigabe, und sie lässt sich jederzeit zurücknehmen. Deshalb
 * gilt „Los geht's" für den Chat und erlaubt, dass die App bei Bedarf nach
 * Mikrofon und Kamera fragt.
 */
export function ConsentScreen({ onAccept }: { onAccept: (consent: ConsentValue) => void }) {
  const t = useT()
  return (
    <div className="flex min-h-full flex-col items-center justify-center gap-10 px-6 py-14 text-center">
      <Avatar state="idle" size={112} showLabel={false} />
      <div className="max-w-md space-y-4">
        <h1 className="text-4xl sm:text-5xl">{t.consentHello}</h1>
        <p className="leading-relaxed text-text-muted">{t.consentIntro}</p>
        <p className="text-sm text-text-muted">{t.consentData}</p>
      </div>

      <div className="w-full max-w-md">
        <button
          type="button"
          onClick={() => onAccept({ ai: true, microphone: true, camera: true })}
          className="w-full rounded-full bg-accent px-6 py-4 text-lg font-semibold text-on-accent shadow-float transition"
        >
          {t.consentGo}
        </button>
        <p className="mt-3 text-xs text-text-muted">{t.consentNote}</p>
      </div>
    </div>
  )
}
